import React, { Component } from 'react';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { PrivacyPolicies } from '@acri-tools/gdpr-library';
import { bannerImage } from '../../theme/images';
import routes from '../../utils/routes';
import Footer from '../../components/Footer/Footer';
import { PRIVACY_SETTINGS_PATH } from '../../gdpr/setup';
import './Gdpr.css';

const DataTable = ({
    headers,
    rows,
}: {
    headers: [string, string];
    rows: [string, string][];
}) => (
    <table className="gdpr-data-table">
        <thead>
            <tr>
                <th>{headers[0]}</th>
                <th>{headers[1]}</th>
            </tr>
        </thead>
        <tbody>
            {rows.map((row) => (
                <tr key={row[0]}>
                    <td>{row[0]}</td>
                    <td>{row[1]}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default class Gdpr extends Component {
    render() {
        return (
            <Page
                id="gdpr"
                footer={<Footer />}
                banner={{
                    bannerImage: bannerImage,
                    topBar: {
                        routes: routes,
                        disableLogo: true,
                    },
                }}
            >
                <div className="page-content gdpr-page">
                    <PrivacyPolicies
                        title="GDPR Notice | Notice RGPD"
                        privacySettingsPath={PRIVACY_SETTINGS_PATH}
                    >
                        <h2>Personal information / Informations personnelles</h2>
                        <p>
                            Some information about how to access the site may be received by our computer systems, such as
                            the visitor's IP address. This information is not collected for explicit use (for example, to
                            contact a user or for advertising). They are nevertheless recorded in system logs from systems and
                            equipment that allow access and execution of the site (e.g. FireWall, Operating System). This
                            information is not explicitly correlated with any personal information (e.g. user name), unless duly
                            indicated in this notice.
                        </p>
                        <p>
                            Similarly, login data (email address, password) is saved and used only to allow access to the site.
                        </p>
                        <p>
                            By registering, you agree to be contacted via the email address provided when creating this account.
                            This email address will be used to inform you of updates, whether they concern changes to the
                            platform's usage policy or new features. This data is retained until the User account is deleted.
                        </p>
                        <p>
                            Any information that may be voluntarily provided by a user (e.g. name and email address or
                            telephone number in a contact form) is only used for the function required by the user (e.g. to
                            respond to a contact request).
                        </p>
                        <div className="gdpr-translation">
                            <p>
                                Certaines informations d’accès au site sont susceptibles d’être reçues par nos systèmes informatiques,
                                comme l’adresse IP du visiteur. Ces informations ne sont pas recueillies pour être utilisées de façon
                                explicite (par exemple pour contacter un utilisateur ou pour de la publicité). Elles sont néanmoins
                                enregistrées dans des journaux systèmes en provenance des systèmes et équipements qui permettent
                                l’accès et l’exécution du site (par exemple : FireWall, Système d’exploitation). Ces informations ne
                                sont pas explicitement corrélées avec d’éventuelles informations personnelles (par exemple le nom
                                d’utilisateur), sauf dûment indiqué dans cette notice.
                            </p>
                            <p>
                                De la même manière les données de connexion (adresse email, mot de passe) ne sont enregistrées et
                                utilisées que pour permettre l’accès au site.
                            </p>
                            <p>
                                En vous inscrivant, vous acceptez d’être contactés via l’email fourni lors de la création de ce compte.
                                Cet email sera notamment utilisé pour vous informer des mises à jour, qu’il s’agisse de modification
                                dans la politique d’utilisation de la plateforme ou de nouveautés fonctionnelles. Ces données sont
                                conservées jusqu’à la suppression du compte Utilisateur.
                            </p>
                            <p>
                                Les informations éventuellement transmises volontairement par un utilisateur (par exemple son nom
                                et son adresse email ou son numéro de téléphone dans un formulaire de contact) ne sont utilisées que
                                pour la fonction requise par l’utilisateur (par exemple, pour lui répondre lors d’une demande de
                                contact).
                            </p>
                        </div>

                        <h2>Cookies</h2>
                        <p>
                            We use Core cookies that are essential to provide our web sites services. For example, these include
                            cookies to note you’ve accepted our personal data policy or cookies to make it possible for you to
                            stay logged into our Web site (the latter being applicable only to sites where a user login function
                            exists).
                        </p>
                        <p>
                            In addition, we may use cookies to track our Web site usage, through third-party technologies such
                            as Google Analytics. This is used to make anonymous statistics about new visits, return visits and
                            page views. These usage cookies measure how often visitors navigate to our sites and which pages
                            are visited. We use this anonymous information to get a better sense of how our content is relevant
                            to visitors and to improve our sites (for example, we collect information about which of our pages
                            are most frequently visited). In that respect we may use third-party cookies (for example, the Google
                            Analytics cookie provide information such as navigation between pages). This anonymous
                            information may be shared with third party to provide anonymous statistics on the site usage (for
                            example we may share project site usage information with project stakeholders).
                        </p>
                        <p>We don’t use Advertising cookies.</p>
                        <p>
                            Note: you can always set your browser to block these cookies. In such a case, functions and services
                            above will not work. For example, we won’t be able to save your personal data policy consent.
                        </p>
                        <div className="gdpr-translation">
                            <p>
                                Nous utilisons des cookies qui sont essentiels pour fournir les services de nos sites Web. Par exemple,
                                il s'agit de cookies pour indiquer que vous avez accepté notre politique en matière de données
                                personnelles ou de cookies pour vous permettre de rester connecté à notre site Web (ces derniers
                                étant applicables uniquement aux sites où une fonction de connexion utilisateur existe).
                            </p>
                            <p>
                                En outre, nous pouvons utiliser des cookies pour suivre l'utilisation de notre site Web, par le biais de
                                technologies tierces telles que Google Analytics. Ceci est utilisé pour faire des statistiques anonymes
                                sur les nouvelles visites, les retours et les pages vues. Ces cookies d'utilisation mesurent la fréquence à
                                laquelle les visiteurs naviguent sur nos sites et quelles pages sont visitées. Nous utilisons ces
                                informations anonymes pour avoir une meilleure idée de la pertinence de notre contenu pour les
                                visiteurs et pour améliorer nos sites (par exemple, nous recueillons des informations sur les pages les
                                plus fréquemment visitées). À cet égard, nous pouvons utiliser des cookies tiers (par exemple, le
                                cookie Google Analytics fournit des informations telles que la navigation entre les pages). Ces
                                informations anonymes peuvent être partagées avec des tiers pour fournir des statistiques anonymes
                                sur l'utilisation du site (par exemple, nous pouvons partager des informations sur l'utilisation du site
                                d’un projet avec les parties prenantes du projet).
                            </p>
                            <p>Nous n'utilisons pas de cookies publicitaires.</p>
                            <p>
                                Note : vous pouvez toujours configurer votre navigateur pour bloquer ces cookies. Dans ce cas, les
                                fonctions et services ci-dessus ne fonctionneront pas. Par exemple, nous ne serons pas en mesure de
                                sauvegarder votre consentement à la politique sur les données personnelles.
                            </p>
                        </div>

                        <h2>Registered data / Données enregistrées</h2>
                        <p>We collect only required personal data, used like describe below :</p>
                        <DataTable
                            headers={['Registered data', 'Purpose of data']}
                            rows={[
                                ['Username', 'For contact, customized account and authentication'],
                                ['Password', 'For login'],
                                ['Email', 'For login and to contact user and send information'],
                            ]}
                        />
                        <div className="gdpr-translation">
                            <p>Nous n’enregistrons que les données personnelles nécessaires, utilisées pour les raisons suivantes :</p>
                            <DataTable
                                headers={['Donnée enregistrée', 'Objectif de la donnée']}
                                rows={[
                                    ['Nom d’utilisateur', 'Pour contact, personnalisation du compte et authentification'],
                                    ['Password', 'Pour login'],
                                    ['Email', 'Pour login et pour contacter l’utilisateur et envoyer des informations'],
                                ]}
                            />
                        </div>

                        <h2>Data retention / Conservation des données</h2>
                        <p>
                            Personal data are registered and kept during a limited duration of 6 years, according to RGPD art.5.
                            When a user does not connect for 6 years then his personal data are automatically deleted. However,
                            if a user wants to delete his personal information before this delay, he can contact our service
                            without any explanation.
                        </p>
                        <p className="gdpr-translation">
                            Les données personnelles sont conservées en base active durant une période de 6 ans, en accord avec
                            l’article 5 du RGPD. Si un utilisateur ne se connecte plus pendant une période supérieure à 6 ans alors
                            ses données personnelles sont automatiquement effacées. Toutefois, si un utilisateur souhaite
                            supprimer ses données personnelles sans attendre ce délai il peut contacter nos services sans avoir
                            besoin de fournir les raisons de sa motivation.
                        </p>

                        <h2>Disclosure of data – Legal requirements / Divulgation des données – Obligations légales</h2>
                        <p>We may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
                        <ul>
                            <li>To comply with a legal obligation</li>
                            <li>To protect and defend our rights or property</li>
                            <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                            <li>To protect the personal safety of users of the Service or the public</li>
                            <li>To protect against legal liability</li>
                        </ul>
                        <div className="gdpr-translation">
                            <p>Nous pouvons divulguer vos Données Personnelles de bonne foi lorsqu'une telle action est nécessaire pour :</p>
                            <ul>
                                <li>Se conformer à une obligation légale</li>
                                <li>Protéger et défendre nos droits ou nos biens</li>
                                <li>Prévenir ou enquêter sur d'éventuels actes répréhensibles en rapport avec le Service</li>
                                <li>Protéger la sécurité personnelle des utilisateurs du Service ou du public</li>
                                <li>Se prémunir en responsabilité civile</li>
                            </ul>
                        </div>

                        <h2>Security of data / Sécurité des données</h2>
                        <p>
                            The security of your data is important to us but remember that no method of transmission over the
                            Internet, or method of electronic storage is 100% secure. While we strive to use commercially
                            acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
                        </p>
                        <p className="gdpr-translation">
                            La sécurité de vos données est importante pour nous, mais aucune méthode de transmission sur
                            Internet ou de stockage électronique n'est sûre à 100%. Bien que nous nous efforcions d'utiliser des
                            moyens commercialement acceptables pour protéger vos données personnelles, nous ne pouvons
                            garantir leur sécurité absolue.
                        </p>

                        <h2>Services providers / Fournisseurs de services</h2>
                        <p>
                            We may employ third party companies and individuals to facilitate our Service (“Service Providers”),
                            to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing
                            how our Service is used. These third parties have access to your Personal Data only to perform these
                            tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                        </p>
                        <p className="gdpr-translation">
                            Nous pouvons faire appel à des sociétés et personnes tierces dans le cadre de l’exploitation de nos
                            Services ("Fournisseurs de services "), pour fournir le Service en notre nom, pour fournir des services
                            liés au Service ou pour nous aider à analyser comment notre Service est utilisé. Ces tiers n'ont accès à
                            vos données personnelles que pour effectuer ces tâches en notre nom et sont tenus de ne pas les
                            divulguer ou les utiliser à d'autres fins.
                        </p>

                        <h2>Links to other sites / Liens vers d’autres sites</h2>
                        <p>
                            Our Service may contain links to other sites that are not operated by us. If you click on a third party
                            link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy
                            of every site you visit. We have no control over and assume no responsibility for the content, privacy
                            policies or practices of any third party sites or services.
                        </p>
                        <p>
                            This website may include links to other websites which may be of interest to you. We do not endorse
                            or approve and have no responsibility for the content of any website to which this website links.
                        </p>
                        <p>
                            No authority is given (implied or expressly) by us or the contributors to the website to deep link to or
                            to frame any of the content that appears on the website or to use a representation of any of our
                            names or logos, trademarks, brand names contained on this website. We reserve the right to prohibit
                            links to our homepage.
                        </p>
                        <div className="gdpr-translation">
                            <p>
                                Notre Service peut contenir des liens vers d'autres sites qui ne sont pas exploités par nous. Si vous
                                cliquez sur un lien tiers, vous serez dirigé vers le site de ce tiers. Nous vous conseillons vivement de
                                consulter la politique de confidentialité de chaque site que vous visitez. Nous n'avons aucun contrôle
                                et n'assumons aucune responsabilité quant au contenu, aux politiques de confidentialité ou aux
                                pratiques des sites ou services de tiers.
                            </p>
                            <p>
                                Ce site Web peut inclure des liens vers d'autres sites Web susceptibles de vous intéresser. Nous
                                n'endossons ni n'approuvons le contenu d'aucun des sites Web vers lesquels ce site Web offre des
                                liens, et nous n'assumons aucune responsabilité à cet égard.
                            </p>
                            <p>
                                Aucune autorité n'est donnée (implicite ou expresse) par nous ou par les contributeurs au site Web
                                pour créer des liens ou encapsulation de contenu, ou pour encadrer le contenu qui apparaît sur le site
                                Web ou pour utiliser une représentation de nos noms ou logos, marques de commerce ou noms de
                                marque contenus sur ce site. Nous nous réservons le droit d'interdire les liens vers notre page
                                d'accueil.
                            </p>
                        </div>

                        <h2>Children’s privacy / protection des mineurs</h2>
                        <p>
                            Our Service does not address anyone under the age of 15 (“Children”). We do not knowingly collect
                            personally identifiable information from anyone under the age of 15. If you are a parent or guardian
                            and you are aware that your Children has provided us with Personal Data, please contact us. If we
                            become aware that we have collected Personal Data from children without verification of parental
                            consent, we take steps to remove that information from our servers.
                        </p>
                        <p className="gdpr-translation">
                            Notre service ne s'adresse pas aux personnes âgées de moins de 15 ans (" enfants"). Nous ne
                            recueillons pas sciemment de renseignements personnels identifiables auprès de toute personne âgée
                            de moins de 15 ans. Si vous êtes un parent ou un tuteur et que vous savez que vos enfants nous ont
                            fourni des données personnelles, veuillez nous contacter. Si nous apprenions que nous avons recueilli
                            des données personnelles d'enfants sans vérification du consentement parental, nous prendrions des
                            mesures pour supprimer ces informations de nos serveurs.
                        </p>

                        <h2>Users rights / Droits des utilisateurs</h2>
                        <p>As our website user, you have the following rights:</p>
                        <ul>
                            <li>Access to your personal data</li>
                            <li>Rectification / editing your data</li>
                            <li>Delete it when it is no longer necessary limit</li>
                            <li>Restrict access to oppose the use of automated decision-making (profiling)</li>
                            <li>Request a copy of your data</li>
                            <li>Right to seek compensation for damages caused by a violation of the right</li>
                            <li>Make a complain to a control authority</li>
                        </ul>
                        <p>If you want to use your rights or if you have any questions about this Privacy Policy, please contact us.</p>
                        <ul>
                            <li>Email : privacy@acri-st.fr</li>
                            <li>Phone : +33 (0)4 92 92 75 00</li>
                            <li>Address : 260 route du Pin Montard, B.P. 234, 06904 Sophia-Antipolis, France</li>
                        </ul>
                        <div className="gdpr-translation">
                            <p>En tant qu'utilisateur de notre site Web, vous avez les droits suivants :</p>
                            <ul>
                                <li>Accès à vos données personnelles</li>
                                <li>Rectification / modification de vos données</li>
                                <li>Supprimer vos données lorsqu'elles ne sont plus nécessaires</li>
                                <li>Restreindre l'accès pour s'opposer à l'utilisation de décision automatisée (profilage)</li>
                                <li>Demander une copie de vos données</li>
                                <li>Demander réparation pour les dommages causés par une violation de ce droit</li>
                                <li>Déposer une plainte auprès d'une autorité de contrôle</li>
                            </ul>
                            <p>
                                Si vous souhaitez faire valoir vos droits ou si vous avez des questions concernant cette politique de
                                confidentialité vous pouvez nous contacter.
                            </p>
                            <ul>
                                <li>E-mail : privacy@acri-st.fr</li>
                                <li>Téléphone : +33 (0)4 92 92 75 00</li>
                                <li>Adresse postale : 260 route du Pin Montard, B.P. 234, 06904 Sophia-Antipolis, France</li>
                            </ul>
                        </div>

                        <h2>Disclaimer / Clause de non-responsabilité</h2>
                        <p>
                            Whilst we have taken every reasonable precaution and care in compiling this website, we do not
                            make any representation or warranties of any kind (express or implied) with respect to the contents
                            or operation of this website, and any such representations and warranties are excluded by this
                            notice. We do not warrant that use of this website will be uninterrupted or error free. Your use of
                            this website and the materials contained in it are done so entirely at your own risk. We do not accept
                            any liability for losses or damages, whether direct or indirect, that you may suffer as a result of your
                            use of this website or your reliance upon the contents of this website including but not limited to
                            computer service or system failure, access delays or interruption, data non-delivery or mis-delivery,
                            computer viruses or other harmful components, breaches of security or unauthorized use of the
                            system arising from “hacking” or otherwise.
                        </p>
                        <p>
                            This website is made available on the basis that (except in respect of fraud or of death or personal
                            injury caused by our negligence), all liability whatsoever for any loss or damage arising out of or in
                            connection with your use of this website, or reliance upon the contents of this website, is excluded to
                            the fullest extent permitted by law.
                        </p>
                        <p>
                            Any typographical, clerical or other error or omission in any page posted on this website shall be
                            subject to correction or deletion (as appropriate) without any liability on our part.
                        </p>
                        <p>
                            We reserve the right to make changes to this website at any time without notice and it is your
                            responsibility to revisit this page from time to time to re-read this notice. Any revised terms shall
                            take effect as at the date of its posting.
                        </p>
                        <p>
                            The content of this website, any dispute arising out of the website, and your relationship with us are
                            governed by French law and shall be subject to the exclusive jurisdiction of the French Courts.
                        </p>
                        <div className="gdpr-translation">
                            <p>
                                Bien que nous prenions toutes les précautions raisonnables pour la création et la maintenance de ce
                                site Web, nous ne donnons aucune garantie (expresse ou implicite) quant au contenu ou au
                                fonctionnement de ce site Web. Nous ne garantissons pas que l'utilisation de ce site Web sera
                                ininterrompue ou sans erreur. Votre utilisation de ce site Web et des informations qu'il contient se fait
                                entièrement à vos propres risques. Nous n'acceptons aucune responsabilité pour les pertes ou
                                dommages, directs ou indirects, que vous pourriez subir en raison de votre utilisation de ce site Web
                                ou de votre confiance dans le contenu de ce site Web, y compris, mais sans s'y limiter, le service
                                informatique ou la défaillance de système, les retards ou interruptions d'accès, la non-livraison ou la
                                mauvaise livraison des données, les virus informatiques ou autres composants nuisibles, les violations
                                de sécurité ou l'utilisation non autorisée du système résultant de "piratage" ou autre.
                            </p>
                            <p>
                                Ce site Web est mis à votre disposition sur la base que (sauf cas de fraude ou décès ou dommages
                                corporels causés par notre négligence) toute responsabilité, quelle qu'elle soit, pour toute perte ou
                                dommage découlant de ou en relation avec votre utilisation de ce site Web, ou de la confiance
                                accordée à son contenu, est exclue dans toute la mesure permise par la loi.
                            </p>
                            <p>
                                Toute erreur ou omission typographique, d'écriture ou autre dans une page affichée sur ce site Web
                                peut être corrigée ou supprimée (selon le cas) sans aucune responsabilité de notre part.
                            </p>
                            <p>
                                Nous nous réservons le droit d'apporter des modifications à ce site Web n’importe quand sans préavis
                                et il vous incombe de relire cette page de temps à autre pour relire le présent avis. Les conditions
                                révisées prennent effet à la date de leur affichage.
                            </p>
                            <p>
                                Le contenu de ce site Web, tout litige découlant de ce site Web et votre relation avec nous sont régis
                                par la loi française et seront soumis à la juridiction exclusive des tribunaux français.
                            </p>
                        </div>
                    </PrivacyPolicies>
                </div>
            </Page>
        );
    }
}
